import React, { useContext } from 'react'

import Price from '../../../../../src/Organisms/Price'
import { Button, Placeholder } from '@s4l/ds'

import styles from './styles.module.css'

import type { Availability } from '@s4l/stayforlong/booking/Availability'
import { RoomConfiguratorContext } from '../../context'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import { useS4LContext } from '@s4l/react-context'

interface IFooterProps {
  availability?: Availability
  disabled?: boolean
}

function Footer({ availability, disabled }: Readonly<IFooterProps>) {
  const { listOfAvailability, isMultiBooking } = useContext(RoomConfiguratorContext)
  const { i18n } = useS4LContext()

  if (!availability) {
    return null
  }

  return (
    <footer className={styles.container}>
      <span className={styles.priceContainer}>
        <Price nights={listOfAvailability.getNights()} price={availability.price()} />
      </span>
      <Button
        data-testid="button-book-room"
        type="submit"
        disabled={disabled}
        variant="filled-rounded"
        size="medium"
        trailingIcon={<IconArrowRight />}
      >
        {isMultiBooking
          ? i18n.formatMessage({ id: 'global.select' })
          : i18n.formatMessage({ id: 'global.book' })}
      </Button>
    </footer>
  )
}

function FooterPlaceholder() {
  return (
    <footer className={styles.container}>
      <Placeholder width="150px" height="40px" rounded />
      <Placeholder width="150px" height="40px" rounded />
    </footer>
  )
}

Footer.displayName = 'RoomConfigurator.Form.Footer'
FooterPlaceholder.displayName = 'RoomConfigurator.Form.Footer.Placeholder'

Footer.Placeholder = FooterPlaceholder

export default Footer
